import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class CompteRenduEvent extends UserEvent {
  public static NAME = 'COMPTE_RENDU_EVENT';

  constructor(
    public idAffectation: string,
    public champsPersonnalises: ChampCompteRendu[] = [],
    coordinates?: Coordinates
  ) {
    super(CompteRenduEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: CompteRenduEvent): CompteRenduEvent {
    return new CompteRenduEvent(obj.idAffectation, obj.champsPersonnalises, obj.coordinates);
  }
}
